module.exports = __webpack_public_path__ + "static/media/menu-open-dk.fe5cb10e.svg";